/*
 * Qualification Messages
 *
 * This contains all the text for the Qualification container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.Qualification';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Qualifications',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'total',
  },
  test: {
    id: `${scope}.test`,
    defaultMessage: 'Test',
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: 'Date',
  },
  granted: {
    id: `${scope}.granted`,
    defaultMessage: 'Granted by',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  tester: {
    id: `${scope}.tester`,
    defaultMessage: 'Authorized Tester',
  },
  instructor: {
    id: `${scope}.instructor`,
    defaultMessage: 'Instructor',
  },
  upgradeToTester: {
    id: `${scope}.upgradeToTester`,
    defaultMessage: 'Upgrade Member to Tester',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },
  addQualification: {
    id: `${scope}.addQualification`,
    defaultMessage: 'Add Qualification',
  },
});
